document.addEventListener('DOMContentLoaded', function () {

    const stacks = document.querySelectorAll('.af-stack');

    if (!stacks.length) return;


    stacks.forEach(function (stack) {

        const panels = Array.from(
            stack.querySelectorAll('.af-panel')
        );

        if (!panels.length) return;


        /* ==========================================
           ANIMACIÓN DE ENTRADA
        ========================================== */

        const observer = new IntersectionObserver(function (entries) {

            entries.forEach(function (entry) {

                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                } else {
                    entry.target.classList.remove('is-visible');
                }

            });

        }, {
            threshold: 0.45
        });


        panels.forEach(function (panel) {
            observer.observe(panel);
        });


        /* ==========================================
           ESTADO
        ========================================== */

        let currentIndex = 0;

        let isMoving = false;

        let touchStartY = 0;
        let touchStartX = 0;


        /*
         * Control específico del ratón.
         *
         * Evita que varios eventos wheel generados
         * por un mismo gesto provoquen varios banners.
         */

        let wheelLocked = false;

        let wheelUnlockTimer = null;


        /* ==========================================
           COMPROBAR SI ESTAMOS DENTRO DEL STACK
        ========================================== */

        function isInsideStack() {

            const rect =
                stack.getBoundingClientRect();

            const viewportHeight =
                window.innerHeight;

            return (
                rect.top <= viewportHeight * 0.5 &&
                rect.bottom >= viewportHeight * 0.5
            );

        }


        /* ==========================================
           POSICIÓN REAL DEL BANNER
        ========================================== */

        function getPanelTop(panel) {

            return (
                window.scrollY +
                stack.getBoundingClientRect().top +
                panel.offsetTop
            );

        }


        /* ==========================================
           IR A UN BANNER
        ========================================== */

        function goToPanel(index) {

            if (index < 0) {
                index = 0;
            }

            if (index >= panels.length) {
                index = panels.length - 1;
            }


            if (index === currentIndex) {
                return;
            }


            currentIndex = index;

            isMoving = true;


            const targetTop =
                getPanelTop(panels[index]);


            window.scrollTo({

                top: targetTop,

                behavior: 'smooth'

            });


            setTimeout(function () {

                isMoving = false;

            }, 1000);

        }


        /* ==========================================
           RUEDA DEL RATÓN
        ========================================== */

        stack.addEventListener('wheel', function (event) {

            /*
             * No utilizar este sistema en móvil.
             */

            if (window.innerWidth <= 767) {
                return;
            }


            if (!isInsideStack()) {
                return;
            }


            /*
             * Ignorar movimientos horizontales.
             */

            if (
                Math.abs(event.deltaX) >
                Math.abs(event.deltaY)
            ) {
                return;
            }


            /*
             * Si estamos animando un banner,
             * bloquear cualquier nueva orden.
             */

            if (isMoving) {

                event.preventDefault();

                return;

            }


            /*
             * Si ya hemos procesado un gesto de rueda,
             * ignoramos los siguientes eventos que
             * pertenezcan al mismo gesto.
             */

            if (wheelLocked) {

                event.preventDefault();

                return;

            }


            /*
             * Ignorar movimientos demasiado pequeños.
             */

            if (Math.abs(event.deltaY) < 8) {
                return;
            }


            /* ======================================
               SCROLL HACIA ABAJO
            ====================================== */

            if (event.deltaY > 0) {

                /*
                 * Último banner:
                 *
                 * NO bloqueamos el navegador.
                 * Esto permite llegar al footer.
                 */

                if (
                    currentIndex >=
                    panels.length - 1
                ) {

                    return;

                }


                event.preventDefault();


                /*
                 * Bloqueamos inmediatamente
                 * los siguientes eventos wheel.
                 */

                wheelLocked = true;


                goToPanel(
                    currentIndex + 1
                );


                /*
                 * Mantenemos el bloqueo durante
                 * toda la transición y un pequeño
                 * margen adicional.
                 */

                clearTimeout(wheelUnlockTimer);

                wheelUnlockTimer = setTimeout(function () {

                    wheelLocked = false;

                }, 1250);


                return;

            }


            /* ======================================
               SCROLL HACIA ARRIBA
            ====================================== */

            if (event.deltaY < 0) {

                /*
                 * Primer banner:
                 *
                 * Permitimos al navegador salir
                 * de la galería hacia arriba.
                 */

                if (currentIndex <= 0) {

                    return;

                }


                event.preventDefault();


                /*
                 * Bloqueamos inmediatamente
                 * los siguientes eventos wheel.
                 */

                wheelLocked = true;


                goToPanel(
                    currentIndex - 1
                );


                clearTimeout(wheelUnlockTimer);

                wheelUnlockTimer = setTimeout(function () {

                    wheelLocked = false;

                }, 1250);


                return;

            }

        }, {
            passive: false
        });


        /* ==========================================
           TOUCH START
        ========================================== */

        stack.addEventListener('touchstart', function (event) {

            if (!event.touches.length) {
                return;
            }


            touchStartY =
                event.touches[0].clientY;

            touchStartX =
                event.touches[0].clientX;

        }, {
            passive: true
        });


        /* ==========================================
           TOUCH MOVE
        ========================================== */

        stack.addEventListener('touchmove', function (event) {

            if (!isInsideStack()) {
                return;
            }


            if (!event.touches.length) {
                return;
            }


            const currentY =
                event.touches[0].clientY;

            const currentX =
                event.touches[0].clientX;


            const differenceY =
                touchStartY - currentY;

            const differenceX =
                touchStartX - currentX;


            /*
             * Ignorar movimientos horizontales.
             */

            if (
                Math.abs(differenceX) >
                Math.abs(differenceY)
            ) {
                return;
            }


            /*
             * Todavía no sabemos si será un swipe.
             */

            if (Math.abs(differenceY) < 10) {
                return;
            }


            /*
             * Swipe hacia arriba.
             */

            if (differenceY > 0) {

                /*
                 * Último banner:
                 * permitimos continuar hacia el footer.
                 */

                if (
                    currentIndex >=
                    panels.length - 1
                ) {
                    return;
                }

            }


            /*
             * Swipe hacia abajo.
             */

            if (differenceY < 0) {

                /*
                 * Primer banner:
                 * permitimos salir hacia arriba.
                 */

                if (currentIndex <= 0) {
                    return;
                }

            }


            /*
             * Estamos entre banners.
             *
             * Bloqueamos el scroll libre.
             */

            event.preventDefault();

        }, {
            passive: false
        });


        /* ==========================================
           TOUCH END
        ========================================== */

        stack.addEventListener('touchend', function (event) {

            if (isMoving) {
                return;
            }


            if (!event.changedTouches.length) {
                return;
            }


            const touchEndY =
                event.changedTouches[0].clientY;

            const touchEndX =
                event.changedTouches[0].clientX;


            const differenceY =
                touchStartY - touchEndY;

            const differenceX =
                touchStartX - touchEndX;


            /*
             * Ignorar gestos horizontales.
             */

            if (
                Math.abs(differenceX) >
                Math.abs(differenceY)
            ) {
                return;
            }


            /*
             * Ignorar movimientos pequeños.
             */

            if (Math.abs(differenceY) < 50) {
                return;
            }


            /* ======================================
               SWIPE HACIA ARRIBA
            ====================================== */

            if (differenceY > 0) {

                if (
                    currentIndex <
                    panels.length - 1
                ) {

                    goToPanel(
                        currentIndex + 1
                    );

                }

                return;
            }


            /* ======================================
               SWIPE HACIA ABAJO
            ====================================== */

            if (differenceY < 0) {

                if (currentIndex > 0) {

                    goToPanel(
                        currentIndex - 1
                    );

                }

            }

        }, {
            passive: true
        });


    });

});